import formattedValue from './formattedValue'

const suggestedChanges = {
  formattedValue,
}

export default suggestedChanges
